<template>
  <div>
    <div class="slideContainer">
      <div class="imageContainer" v-for="(slide, index) in data" :key="index" @click="gotoSlide(slide)">
        <div
          class="loadingContainer"
          :style="slide.isImageLoaded == true ? 'display:none' : 'display:flex'"
        >
          <div class="loader"></div>
        </div>
        <img :src="'./slides/' + slide.path" loading="lazy" @load="imageLoaded(slide)"/>
        <div class="timeText">{{ slide.showTime }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import "../scss/slide-content.css";
import timeMixin from '../mixins/timeMixin'
import Vue from 'vue'

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods:{
    runFirstLoad(){
      this.$parent.resize();
    },
    gotoSlide(item){
      this.$parent.$parent.seektoTime(item.showTimeInSeconds,true);
    },
    imageLoaded(slide){
      slide.isImageLoaded=true
      this.$parent.resize();
    }
  },
  created(){
    for(var i=0;i<this.data.length;i++){
      this.data[i].showTimeInSeconds=this.convertHoursMinsSecsToSeconds(this.data[i].showTime)
      Vue.set(this.data[i], "isImageLoaded", false);
    }
  },
  mixins:[timeMixin]
};
</script>

<style>
</style>
